import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-centers-center-gps-radio-card',
  templateUrl: './centers-center-gps-radio-card.component.html',
  styleUrls: ['./centers-center-gps-radio-card.component.scss']
})
export class CentersCenterGpsRadioCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() center;
  basicDataForm = new FormGroup({
    maxRadius: new FormControl({value: null }, Validators.required)
  });
  updateCenterMaxRadiusSubscription: Subscription;

  constructor(private centersCentersService: CentersCentersService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.center && (this.center.MaxRadius || this.center.MaxRadius === 0)) {
      this.resetForm();
    }
  }

  public inputChange() {
    if (this.basicDataForm.get('maxRadius').dirty) {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
        this.resetForm();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateCenterMaxRadiusSubscription = this.centersCentersService.updateCenterRadius(this.center.InternalId, this.basicDataForm.get('maxRadius').value * 1000).pipe(
        tap(o => this.snackbarService.open(o['message'], 'success')),
        catchError(error => { this.snackbarService.open(error['message'], 'error'); return EMPTY; })
      ).subscribe();
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      maxRadius: this.center.MaxRadius / 1000
    });
  }

  public validateForm() {
    if (!this.basicDataForm.get('maxRadius').valid || this.basicDataForm.get('maxRadius').value < 0) {
      return 'stores-page.snackbar messages.center radio gps error';
    } else {
      return true;
    }
  }

  ngOnDestroy() {
    if (this.updateCenterMaxRadiusSubscription) { this.updateCenterMaxRadiusSubscription.unsubscribe(); }
  }
}
